import React, { memo } from 'react';
import { css, useTheme } from '@emotion/react';
import { ContainerLayout } from '../../../layouts/ContainerLayout';
import { ANCHOR_SCROLL_MARGIN, useAnchorScroll } from '../../../hooks/useAnchorScroll';
import type { ContainerEntryType } from 'tsconfig/types';

export type CmsContainerProps = {
  children: React.ReactNode;
  alignment?: ContainerEntryType['fields']['alignment'];
  backgroundColour?: ContainerEntryType['fields']['backgroundColour'];
  pageWidthToggle?: ContainerEntryType['fields']['pageWidthToggle'];
  fluidWidth?: ContainerEntryType['fields']['fluidWidth'];
  anchorId?: ContainerEntryType['fields']['anchorId'];
};

export const CmsContainer = memo((props: CmsContainerProps) => {
  const { children, backgroundColour, alignment, pageWidthToggle, fluidWidth, anchorId } = props;
  const theme = useTheme();

  useAnchorScroll(anchorId);

  const bgColor = backgroundColour
    ? (theme.colors.bgColors as unknown as Record<string, string>)[backgroundColour]
    : 'initial';

  const container = css`
    ${theme.widgets?.CmsContainer}
    ${anchorId && `scroll-margin-top: ${ANCHOR_SCROLL_MARGIN};`}
    ${anchorId && `&:focus-visible { outline: none; }`}
    ${backgroundColour && !pageWidthToggle && `background: ${bgColor};`}
    ${backgroundColour && !pageWidthToggle && `background-color: ${backgroundColour};`}
    ${alignment && `text-align: ${alignment.toLowerCase()};`}
  `;
  const fluidWidthStyle = fluidWidth && { padding: '0px' };

  return (
    <div
      id={anchorId || undefined}
      tabIndex={anchorId ? -1 : undefined}
      data-test="widget-container"
      css={container}
      className={`widget-container ${fluidWidth ? 'fluid-container' : ''}`}
    >
      <ContainerLayout
        fluid={fluidWidth}
        style={{
          background: bgColor,
          backgroundColor: backgroundColour ?? 'initial',
        }}
        css={fluidWidthStyle}
      >
        {children}
      </ContainerLayout>
    </div>
  );
});
